import React from 'react';
import { Card, List, Space, Statistic, Typography } from 'antd';
import { formatDate } from 'utils/date';

const { Text, Title } = Typography;

const Mobile = ({ viewModel }) => {
  const { summary, packageLabels } = viewModel;

  return (
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      <Title level={5} style={{ margin: 0 }}>Tổng quan Shop</Title>

      <Card size='small'>
        <Statistic title='Tổng số shop' value={summary.totalShops} />
      </Card>

      {Object.keys(packageLabels).map((key) => (
        <Card size='small' key={key}>
          <Statistic title={`Shop gói ${packageLabels[key]}`} value={summary.byPackage[key] || 0} />
        </Card>
      ))}

      <Card size='small'>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          <Text strong>Shop mới trong 7 ngày gần đây</Text>
          <List
            dataSource={summary.newShops || []}
            locale={{ emptyText: 'Không có shop mới' }}
            renderItem={(record) => (
              <List.Item style={{ padding: '8px 0' }}>
                <Space direction='vertical' size={2} style={{ width: '100%' }}>
                  <Text strong>{record?.web_site?.title || '-'}</Text>
                  <Text type='secondary'>{record?.web_site?.url ? `${record.web_site.url}.sipro.store` : '-'}</Text>
                  <Text>{record?.owner?.full_name || '-'} - {record?.owner?.phone || '-'}</Text>
                  <Text type='secondary'>Gói: {packageLabels[record?.subscription?.tier || 'mien_phi'] || 'Miễn phí'}</Text>
                  <Text type='secondary'>Tạo lúc: {formatDate(record?.create_on)}</Text>
                </Space>
              </List.Item>
            )}
          />
        </Space>
      </Card>
    </Space>
  );
};

export default Mobile;
